import React from "react";
import Cropper from "react-easy-crop";

function Crop({ image,objectFit,zoom, crop,width,height,cropSize, aspect,onCropChange,onCropComplete,onZoomChange }) {
  return (
    <>
      <Cropper image={image} zoom={zoom} onZoomChange={onZoomChange} objectFit={objectFit} cropSize={cropSize} width={width} height={height} crop={crop} aspect={aspect} onCropChange={onCropChange} onCropComplete={onCropComplete}/>
    </>
  );
}

export default Crop;